

var isMainWrapper = document.querySelector('.wrapper').classList.contains('main_wrapper');

import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
const clientsSwiper = new Swiper('.clients_slider', {
  slidesPerView: isMainWrapper ? 6 : 5,
  spaceBetween: 20,
    speed: 1000,
    loop: 'true',
    navigation: {
        nextEl: ".clients .swiper-button-next",
        prevEl: ".clients .swiper-button-prev",
    },
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
      0: {
          slidesPerView: 1.3,
          spaceBetween: 10,
      },
      576: {
          slidesPerView: 2,
      },
      768: {
          slidesPerView: isMainWrapper ? 3 : 2
      },
      992: {
          slidesPerView: isMainWrapper ? 4 : 3
      },
      1366: {
          slidesPerView: isMainWrapper ? 5 : 4
      },
      1920: {
          slidesPerView: isMainWrapper ? 6 : 5,
      },
    },
});
